import type {State} from 'src/reducers';
import type {Rule} from 'src/types/scheduler/templates';
import type {SchedulerTemplateForm} from 'src/types/scheduler/template-form';

import {NO_AVAILABILITY_RULE} from 'src/components/scheduler/template-editor/constants';
import {CONFLICT_PREVENTION_RULE_TYPES} from 'src/components/scheduler/template-editor/common/conflict-prevention-rules/utils';


export const selectTemplateForm = (state: State): SchedulerTemplateForm => {
  return state.scheduler.templateForm;
};

export const selectTemplateFormRules = (state: State): Rule[] => {
  return state.scheduler.templateForm.rules || [];
};

export const selectConflictPreventionRules = (state: State): Rule[] => {
  const rules = selectTemplateFormRules(state);

  return (
    rules.filter((rule) =>
      (CONFLICT_PREVENTION_RULE_TYPES as readonly string[]).includes(
        rule.ruleType,
      ),
    ) || []
  );
};

export const selectNoAvailabilityRules = (state: State): Rule[] => {
  const rules = selectTemplateFormRules(state);
  return rules.filter((rule) => rule.ruleType === NO_AVAILABILITY_RULE) || [];
};
